import script from "./HelixMedia.vue?vue&type=script&setup=true&lang=js"
export * from "./HelixMedia.vue?vue&type=script&setup=true&lang=js"

import "./HelixMedia.vue?vue&type=style&index=0&id=32f0dd45&scoped=true&lang=css"

import exportComponent from "/home/runner/work/helixpay-website/helixpay-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32f0dd45"]])

export default __exports__